export const ApiKey = "AIzaSyBTz1rLSr9VCgeL1ecsTxY7cyyComdVcAQ";

export default ApiKey;
